module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-02-5895001bac5dd2d3e23e95b3a27dc2bf.svg";